<div class="mapping-container">
  <div class="card p-3">
    <h5>Pick Bulk product</h5>
    <div class="search-box">
      <input
        type="text"
        class="form-control"
        placeholder="Type bulk name or SKU (e.g. SUGAR-BULK)"
        [(ngModel)]="bulkSearchTerm"
        (input)="searchBulkProducts()"
        [disabled]="selectedBulkProduct"
      />
      <div
        class="search-results dropdown-menu show"
        *ngIf="bulkSearchResults.length > 0 && !selectedBulkProduct"
      >
        <button
          class="dropdown-item"
          *ngFor="let product of bulkSearchResults"
          (click)="selectBulkProduct(product)"
        >
          {{ displayName(product) }} ({{ product.sku }})
        </button>
      </div>
    </div>

    <div
      *ngIf="selectedBulkProduct"
      class="selected-product mt-3 p-3 border rounded"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h4>{{ selectedBulkProduct.sku }}</h4>
          <p>{{ displayName(selectedBulkProduct) }}</p>
          <div class="d-flex gap-3">
            <span class="badge bg-light text-dark border"
              >Onhand: {{ selectedBulkProduct.stock || 0 }}</span
            >
            <!-- Add more details if available -->
          </div>
        </div>
        <button
          class="btn btn-outline-secondary"
          (click)="clearBulkSelection()"
        >
          Change
        </button>
      </div>
      <div class="text-muted mt-2">
        If your bulk product is not present, create it first from the product
        screen. This panel is for mapping only.
      </div>
    </div>
  </div>

  <div class="card p-3">
    <h5>Attach / Manage</h5>
    <div class="d-flex flex-column gap-3">
      <div>
        <label>Search child candidates</label>
        <input
          type="text"
          class="form-control"
          placeholder="Search product"
          [(ngModel)]="childSearchTerm"
          (input)="searchChildProducts()"
        />
        <div
          class="search-results dropdown-menu show"
          *ngIf="childSearchResults.length > 0"
        >
          <button
            class="dropdown-item"
            *ngFor="let product of childSearchResults"
            (click)="selectChildCandidate(product)"
          >
            <div class="d-flex justify-content-between">
              <strong>{{ product.sku }}</strong>
              <span>{{ displayName(product) }}</span>
            </div>
          </button>
        </div>
      </div>

      <div
        *ngIf="selectedChildCandidate"
        class="selected-child-preview p-2 border rounded bg-light"
      >
        <strong>Selected:</strong> {{ displayName(selectedChildCandidate) }}
      </div>

      <div>
        <label>Conversion (grams)</label>
        <input
          type="number"
          class="form-control"
          placeholder="e.g. 1000"
          [(ngModel)]="conversionFactor"
        />
      </div>

      <button
        class="btn btn-success w-100"
        [disabled]="
          !selectedBulkProduct || !selectedChildCandidate || !conversionFactor
        "
        (click)="attachChild()"
      >
        Attach
      </button>
    </div>
    <div class="text-muted mt-3 small">
      Pick a child from search results first. Conversion is how many grams of
      the parent the child consumes (1 unit).
    </div>
  </div>

  <div class="card p-3">
    <div class="d-flex justify-content-between">
      <h5>Attached children</h5>
      <small class="text-muted">View, edit conversion or remove</small>
    </div>

    <div *ngIf="!selectedBulkProduct" class="text-center text-muted py-5">
      Select a bulk product to view attachments
    </div>

    <div *ngIf="selectedBulkProduct" class="attached-list mt-3">
      <div
        *ngFor="let child of attachedChildren"
        class="attached-item d-flex justify-content-between align-items-center mb-2 p-2 border-bottom"
      >
        <div class="child-info">
          <strong>{{ child.name }}</strong>
          <div class="small text-muted">{{ child.sku }}</div>
          <div class="small text-muted">
            Conversion: {{ child.conversionFactor }} g
          </div>
        </div>
        <div class="actions d-flex gap-2">
          <input
            type="number"
            class="form-control form-control-sm"
            style="width: 80px"
            [(ngModel)]="child.conversionFactor"
          />
          <button class="btn btn-danger btn-sm" (click)="removeChild(child)">
            Remove
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="selectedBulkProduct" class="mt-4 text-end">
      <button class="btn btn-success" (click)="saveMapping()">
        Save mapping
      </button>
    </div>
  </div>
</div>
